import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { baseUrl } from '../shared/baseUrl';
import {Button, Form, Row, Col, FormControl, Alert, Modal, Spinner } from 'react-bootstrap';

export default class ContactForm extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            name: '',            
            email: '',
            phone: '',                    
            message: '', 
            errorMessages: [],                     
            isLoading: false,
            validated: false,
            contactoSatisfactorio: false
        };    
        this.onChange = this.onChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        
    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value });        
    }

    handleSubmit(event) {

        this.setState({            
            contactoSatisfactorio: false,
            validated: false
        });  
        
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();

            this.setState({validated: true}); 
        } else {             
            this.setState({isLoading: true});        
            this.submitContactForm();     
        }            
                  
    }

    submitContactForm() {

        let token = document.head.querySelector('meta[name="csrf-token"]'); 

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ 
                '_token': token.content,
                'name': this.state.name,
                'email': this.state.email,
                'phone': this.state.phone,
                'message': this.state.message 
            })
        };

        fetch(baseUrl + 'submitContactForm',requestOptions)
        .then(async response => {
            const data = await response.json(); 
            
            console.log(data);

            if (data.responseType == 'error') {
                if (data.errors) {                                    
                    this.setState({ errorMessages: data.errors })                        
                } 
                
                this.setState({
                    isLoading: false
                });

            } else if (data.responseType == 'success' ) {                    
                this.setState({                        
                    contactoSatisfactorio: true,
                    name: '',            
                    email: '',
                    phone: '',                    
                    message: '',
                    isLoading: false
                });                     
            }                  
        })
        .catch(error => {                
            console.error('There was an error!', error.toString());
            this.setState({
                isLoading: false
            });
        });

    }

    render() { 
        return(
            <div>

            { this.state.contactoSatisfactorio ? 
            <Alert variant="success">
            <Alert.Heading>Contacto Satisfactorio</Alert.Heading>
            <p>
                Gracias por contactárte con nosotros, nos comunicaremos contigo lo más pronto posible.
            </p>
            </Alert> : null
            }
            <Form validated={this.state.validated} onSubmit={this.handleSubmit} >                
                <Row>
                    <Col>
                        <Form.Group controlId="contactForm.Name">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control required type="text" name="name" value={this.state.name} onChange={this.onChange}  /> 
                            <Form.Control.Feedback type="invalid">Ingrese su nombre.</Form.Control.Feedback>                           
                        </Form.Group>
                    </Col>
                    </Row>
                    <Row>
                    <Col>
                        <Form.Group controlId="contactForm.Email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control required type="email" name="email" value={this.state.email} onChange={this.onChange}  />
                            <Form.Control.Feedback type="invalid">Ingrese un correo válido.</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="contactForm.Phone">
                            <Form.Label>Teléfono</Form.Label>
                            <Form.Control required type="text" name="phone" value={this.state.phone} onChange={this.onChange} />
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Form.Group controlId="contactForm.Message">
                            <Form.Label>Mensaje</Form.Label>
                            <Form.Control required as="textarea" name="message" value={this.state.message} onChange={this.onChange} rows="3" />
                            <Form.Control.Feedback type="invalid">Ingrese un mensaje.</Form.Control.Feedback>                           
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button className="button button-3d nomargin" type="submit" disabled={this.state.isLoading} >
                        {this.state.isLoading ? 'Enviando...' : 'Enviar'}
                        </Button>
                    </Col>
                </Row>

            
            </Form>

            <Modal id="modalLoading" size="sm" show={this.state.isLoading} centered  >
                <div className="text-center" >
                    <Spinner animation="border" variant="light" />                        
                </div>
            </Modal>  

            </div>
            
        );
    }

}


if (document.getElementById('contact-form')) {
    const contactForm = document.getElementById('contact-form');
    ReactDOM.render( <ContactForm /> , contactForm);
}